import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Compass, ShoppingBag, User } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { tap } from "../lib/native/haptics";

// Navigazione CLIENTE — 4 macro-aree (radicale semplificazione).
// HOME = Fuma AI · ESPLORA = scoperta (mappa+categorie) · ORDINI = ordini/consegne · PROFILO = account.
const TABS = [
  { id: "home", label: "Home", icon: Home, to: "/home" },
  { id: "esplora", label: "Esplora", icon: Compass, to: "/esplora" },
  { id: "ordini", label: "Ordini", icon: ShoppingBag, to: "/app/orders", auth: true },
  { id: "profilo", label: "Profilo", icon: User, to: "/app/profile", auth: true },
];

// Mappa i vecchi valori "active" alle 4 nuove voci per non perdere l'evidenziazione.
const LEGACY = { mappa: "esplora", scopri: "esplora", attivita: "ordini", ai: "home" };

export default function CustomerTabBar({ active }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const norm = LEGACY[active] || active;
  const isActive = (t) =>
    norm ? norm === t.id : location.pathname === t.to || location.pathname.startsWith(`${t.to}/`);

  return (
    <nav
      data-testid="customer-tabbar"
      className="fixed inset-x-0 bottom-0 z-40 bg-[#0A0A0C]/90 backdrop-blur-xl border-t border-white/10 flex max-w-md mx-auto rounded-t-3xl"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {TABS.map((t) => {
        const act = isActive(t);
        return (
          <button
            key={t.id}
            data-testid={`nav-item-${t.id}`}
            onClick={() => { tap("light"); navigate(t.auth && !user ? "/login" : t.to); }}
            className="flex-1 flex flex-col items-center justify-center gap-1 py-2.5 min-h-[60px] active:scale-95 transition-transform relative"
            aria-current={act ? "page" : undefined}
          >
            {act && <span className="absolute top-0 h-0.5 w-8 rounded-full bg-[#00E676] shadow-[0_0_10px_#00E676]" />}
            <t.icon className={`h-5 w-5 ${act ? "text-[#00E676]" : "text-white/45"}`} />
            <span className={`text-[10px] font-semibold tracking-wide ${act ? "text-[#00E676]" : "text-white/50"}`}>{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
